"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputTextfield = require("@citrus/input-textfield");
var _reactList = _interopRequireDefault(require("@pcty/react-list"));
var _utilsArray = require("@pcty/utils-array");
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _PctyQuestion = require("./PctyQuestion.Common");
require("./index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var PctyQuestionMultipleText = function PctyQuestionMultipleText(_ref) {
  var id = _ref.id,
    number = _ref.number,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    scenario = _ref.scenario,
    required = _ref.required,
    question = _ref.question,
    options = _ref.options,
    response = _ref.response,
    hint = _ref.hint,
    onResponse = _ref.onResponse,
    sortOrder = _ref.sortOrder,
    placeholder = _ref.placeholder;
  var _useState = (0, _react.useState)((0, _PctyQuestion.getSortedOptions)({
      array: options,
      sortOrder: sortOrder
    })),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    sortedOptions = _useState2[0],
    setSortedOptions = _useState2[1];
  (0, _react.useEffect)(function () {
    setSortedOptions((0, _PctyQuestion.getSortedOptions)({
      array: options,
      sortOrder: sortOrder
    }));
  }, [options, sortOrder]);
  var getItemValue = function getItemValue(itemId) {
    var selectedItem = response.length > 0 ? response.find(function (x) {
      return x.optionId === itemId;
    }) : undefined;
    if (selectedItem) {
      return selectedItem.value;
    }
    return undefined;
  };
  var _onChange = function onChange(id, optionId, value) {
    if (readOnly) return;
    var itemResponses = (0, _toConsumableArray2.default)(response);
    var index = (0, _findIndex.default)(itemResponses, function (x) {
      return x.optionId === optionId;
    });
    var newResponse = {
      optionId: optionId,
      value: value
    };
    if (index < 0) {
      itemResponses = [].concat((0, _toConsumableArray2.default)(response), [newResponse]);
    } else {
      itemResponses = (0, _utilsArray.replaceAt)(itemResponses, index, newResponse);
    }
    onResponse(id, itemResponses);
  };
  var getListItems = function getListItems() {
    var retOptions = sortedOptions.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(_reactList.default.Item, {
        automationId: "question-".concat(number, "-multiple-text-item-").concat(index),
        key: "".concat(id, "-mt-item-").concat(index)
      }, /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, item.value), /*#__PURE__*/_react.default.createElement(_reactList.default.Column, null, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
        id: "".concat(id, "-mt-textfield-").concat(index),
        onChange: function onChange(_ref2) {
          var value = _ref2.value;
          return _onChange(id, item.id, value);
        },
        placeholder: placeholder,
        disabled: disabled,
        readOnly: readOnly,
        automationId: "question-".concat(number, "-multiple-text-textfield-").concat(index),
        value: getItemValue(item.id)
      })));
    });
    return retOptions;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(id, hint), (0, _PctyQuestion.renderScenario)(id, scenario), (0, _PctyQuestion.renderQuestion)(id, number, question, required, readOnly), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_reactList.default, {
    className: "pcty-question-builder-single-question-list",
    automationId: "question-".concat(number, "-multiple-text-pctyList")
  }, getListItems()))));
};
PctyQuestionMultipleText.propTypes = {
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** The placeholder text to display in the text fields */
  placeholder: _propTypes.default.string,
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.array,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  /** The sortOrder of the options of the component. */
  sortOrder: _propTypes.default.oneOf(['defined', 'ascending', 'descending', 'random']),
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionMultipleText');
  }
};
PctyQuestionMultipleText.defaultProps = {
  scenario: null,
  sortOrder: 'defined',
  placeholder: 'Enter text',
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionMultipleText'
};
var _default = exports.default = PctyQuestionMultipleText;